export const getNativeConfig = () => {
  return {
    native: {
      allowNavigation: ['*.sdui.dev', '*.sdux.de', 'sdui.app', 'iam.sdui-group.app'],
      appName: 'Konecto-Sdui',
      packageName: 'com.sdui.konecto',
      defaultUrl: 'https://sdui.app',
      android: {
        flavor: 'konecto-sdui'
      },
      ios: {
        Scheme: 'Konecto'
      }
    }
  }
}
